import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const SeccionDetallePeriodo = ({ comparativoMensual, anioActivo, loading, metricaActiva, infoFiltros }) => {
    const [isOpen, setIsOpen] = useState(false);

    const formatMoney = (value) => new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(value);
    const formatNumber = (value) => new Intl.NumberFormat('es-PE').format(value);
    const formatValue = (value) => metricaActiva === 'monto' ? formatMoney(value) : formatNumber(value);

    const isMonto = metricaActiva === 'monto';
    const labelTipo = isMonto ? 'Monto (S/)' : 'Unidades';

    return (
        <div className="shadow-sm mb-4" style={{ border: '2px solid #01a59c', borderRadius: '1.25rem' }}>
            <div
                className="card-header border-bottom p-4 d-flex justify-content-between align-items-center"
                style={{ cursor: 'pointer', backgroundColor: '#35605a', borderRadius: '1.25rem' }}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div>
                    <h4 className="font-weight-bold text-white m-0">
                        <i className="fas fa-chart-bar mr-2 text-white"></i> Detalle por Periodo
                    </h4>
                    {infoFiltros && <div className="mt-1"><small className="text-white"><i className="fas fa-filter mr-1"></i> Filtrando por: {infoFiltros}</small></div>}
                </div>
                <button className='btn btn-light btn-sm rounded-circle'>
                    <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`}></i>
                </button>
            </div>
            {isOpen && (
                <div className="card-body position-relative p-4">
                    {loading && (
                        <div className="position-absolute d-flex justify-content-center align-items-center" style={{ top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255,255,255,0.7)', zIndex: 10 }}>
                            <div className="spinner-border text-primary"></div>
                        </div>
                    )}

                    <h6 className="font-weight-bold text-muted mb-4 text-uppercase">
                        Comparativo mensual ({labelTipo}) {parseInt(anioActivo) - 1} vs. {anioActivo}
                    </h6>

                    <div style={{ width: '100%', height: 350 }}>
                        <ResponsiveContainer>
                            <BarChart data={comparativoMensual} margin={{ top: 20, right: 30, left: 20, bottom: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
                                <XAxis dataKey="mes" axisLine={false} tickLine={false} tick={{ fill: '#888' }} />
                                <YAxis axisLine={false} tickLine={false} tick={{ fill: '#888' }} tickFormatter={(val) => isMonto ? `${val / 1000}k` : formatNumber(val)} />
                                <Tooltip
                                    formatter={(value) => formatValue(value)}
                                    contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', padding: '10px 15px' }}
                                    cursor={{ fill: 'rgba(0,0,0,0.05)' }}
                                />
                                <Legend verticalAlign="top" height={36} iconType="circle" />
                                <Bar name={`${labelTipo} ${parseInt(anioActivo) - 1}`} dataKey={`anio_${parseInt(anioActivo) - 1}_${metricaActiva}`} fill="#82ca9d" radius={[4, 4, 0, 0]} animationDuration={1500} />
                                <Bar name={`${labelTipo} ${anioActivo}`} dataKey={`anio_${anioActivo}_${metricaActiva}`} fill="#8884d8" radius={[4, 4, 0, 0]} animationDuration={1500} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SeccionDetallePeriodo;
